<template>
  <div class="sub-table-container">
    <t-table
      :columns="tableColumns"
      :data="tableList"
      rowKey="id"
      bordered
      stripe
      :rowClassName="handleTableRowClassName"
      class="hide-header"
      :maxHeight="300"
      style="max-height: 300px; overflow: auto"
    >
      <template #table-cell-value="{ row, col }">
        <table-cell-value
          :row="row"
          :col="col"
          :col-name="col.field"
          :show-compare-date="showCompareDate"
          :can-export-num-cols="canExportNumCols"
          @submitSaveCrowd="handleSubmitSaveCrowd"
        ></table-cell-value>
      </template>
    </t-table>
  </div>
</template>

<script>
// import NumPopver from './num-popover';
import dayjs from 'dayjs';
import TableCellValue from '@/views/analysis/event-analysis/components/table-cell-value.vue';
import { savePackageEvent } from '@/api/analysis/custom-analysis';
import { extractMetaConfig, fillValArr, replenishDateVal, getWeiduValueDesc } from '@/utils/helper';

export default {
  components: {
    // NumPopver,
    TableCellValue,
  },
  props: {
    row: {
      type: Object,
    },
    col: {
      type: Object,
    },
    unit: {
      type: String,
      default: 'day',
    },
    showCompareDate: {
      type: Boolean,
    },
    zhibiaoList: {
      type: Array,
    },
    shuxingWeiduList: {
      type: Array,
      default: () => [],
    },
    lastGetDataParams: {
      type: Object,
    },
    lastGetDataParamsCompare: {
      type: Object,
    },
    groupDataObjList: {
      type: Object,
    },
    groupDataObjListCompare: {
      type: Object,
    },
    canExportNumCols: {
      type: Array,
    },
    dateKeys: {
      type: Object, // {baseDateKeys: [], compareDateKeys: []}
    },
  },
  computed: {
    tableColumns() {
      const columns = [];
      columns.push({
        // label: this.row[this.col.field],
        label: '日期',
        title: '日期',
        field: 'date',
        colKey: 'date',
        key: 'date',
        align: 'right',
      });
      this.zhibiaoList.forEach((zhibiaoItem, idx) => {
        columns.push({
          label: zhibiaoItem.zhibiaoTitle,
          title: zhibiaoItem.zhibiaoTitle,
          field: `target_name_${idx}`,
          colKey: `target_name_${idx}`,
          cell: 'table-cell-value',
          key: `target_name_${idx}_${zhibiaoItem.zhibiaoTitle}`,
          type: 'target',
          zhibiaoIdx: idx,
          align: 'right',
        });
      });
      return columns;
    },
  },
  data() {
    return {
      loading: false,
      tableList: [],
    };
  },
  mounted() {
    this.makeTableList();
  },
  methods: {
    makeTableList() {
      const tableList = [];
      const { row, col, unit } = this;
      const { baseDateKeys, compareDateKeys } = this.dateKeys;
      const { zhibiaoList, allWeiduList } = extractMetaConfig(this.lastGetDataParams);
      const weiduList = allWeiduList.filter(item => item.val !== 'all').map(i => i.val);
      const groupDataObjList = this.groupDataObjList.list.filter(item => weiduList.every(i => item[i] === row[i]));
      const { list, dates } = replenishDateVal(
        { dates: this.groupDataObjList.dates, list: groupDataObjList },
        baseDateKeys,
      );
      let compareList = [];
      let compareDates = [];
      if (this.showCompareDate && this.groupDataObjListCompare && this.groupDataObjListCompare.list) {
        const groupDataObjListCompare = this.groupDataObjListCompare.list.filter(item =>
          weiduList.every(i => item[i] === row[i]),
        );
        const compareData = replenishDateVal(
          { dates: this.groupDataObjListCompare.dates, list: groupDataObjListCompare },
          compareDateKeys,
        );
        compareList = compareData.list;
        compareDates = compareData.dates;
      }

      const firstRow = {
        canRowExportCrowd: row.canRowExportCrowd,
        // date: row[col.field],
        date: getWeiduValueDesc(this.lastGetDataParams, { val: col.field }, row),
      };
      this.zhibiaoList.forEach((zhibiaoItem, idx) => {
        firstRow[`target_name_${idx}`] = row[`target_name_${idx}`];
      });
      tableList.push({ ...firstRow, fixed: true });
      tableList.push(firstRow);
      dates.forEach((date, dateIdx) => {
        let compareDate;
        if (this.showCompareDate) {
          compareDate = compareDates[dateIdx]; // 因为根据日期排好序了，所以直接根据索引来取
        }

        const tmpObj = {
          canRowExportCrowd: row.canRowExportCrowd,
          isDateRow: true,
          date: compareDate
            ? [
                dayjs(date).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'),
                dayjs(compareDate).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'),
              ]
            : [dayjs(date).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')],
        };
        list.forEach(item => {
          const valArr = [item.dateValues[dateIdx]];

          if (this.showCompareDate) {
            const compareItem = compareList.find(i => i.target_name === item.target_name);
            if (compareItem) {
              valArr.push(compareItem.dateValues[dateIdx]);
            }
          }
          const zhibiaoIdx = this.zhibiaoList.findIndex(zhibiao => zhibiao.zhibiaoTitle === item.target_name);
          tmpObj[`target_name_${zhibiaoIdx}`] = fillValArr(valArr, this.showCompareDate);
        });
        tableList.push(tmpObj);
      });

      this.tableList = tableList;
    },

    handleTableRowClassName({ row }) {
      const classArr = [];
      if (row.canRowExportCrowd) {
        classArr.push('export-people-row');
      }
      if (row.fixed) {
        classArr.push('fixed');
      }
      return classArr.join(' ');
    },

    checkCanExportCrowd(row, col, idx = 0) {
      const colName = col.field;
      let val = row[colName];
      if (Array.isArray(val)) {
        val = val[idx];
      }
      return this.canExportNumCols.includes(colName) && !!row.canRowExportCrowd && val > 0;
    },

    async handleSubmitSaveCrowd({ row, col, idx = 0 }, { name, desc }, callback) {
      let val = row[col.field];
      if (Array.isArray(val)) {
        val = val[idx];
      }
      if (val > 1000000) {
        this.toast('人群数超20万，暂不支持提取', 'warning');
        return;
      }

      const parentRow = this.row;
      const latitude = {};
      const reqParams = {
        eventInfo: idx === 0 ? this.lastGetDataParams : this.lastGetDataParamsCompare,
        packageName: name,
        packageDesc: desc,
        eventPosition: col.zhibiaoIdx,
        latitude,
      };
      const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all').map(i => i.val);
      weiduList.forEach(w => {
        latitude[w] = parentRow[w];
      });
      if (row.isDateRow) {
        latitude.import_date = row.date[idx];
      }
      // console.log(JSON.stringify(reqParams, null, 2));
      try {
        const packageId = await savePackageEvent({ data: reqParams });
        // eslint-disable-next-line no-unused-expressions
        callback && callback(packageId);
      } finally {
        // nothing
      }
    },
  },
  filters: {
    formatNum(v) {
      return v !== null && v !== undefined ? v.toLocaleString() : '-';
    },
  },
};
</script>

<style lang="less" scoped></style>
